<template>
<div class="page">
    <v-card>
      <v-toolbar dark flat color="primary">
        <v-toolbar-title>{{title}}</v-toolbar-title>
      </v-toolbar>
    </v-card>

    <v-card class="mt-2 pa-4 placeholdersList">
        <div v-for="item of placeholdersList" class="mt-2" :key="item.id">
          <placeholder-item v-if="!item.edit" :placeholder="item" @change-placeholder="changePlaceholder(item)" @remove-placeholder="removePlaceholder(item)"></placeholder-item>
          <placeholder-form v-if="item.edit" :slug="$route.params.slug" :placeholder="item" @success="item.edit = false; refresh()"></placeholder-form>
          <v-divider></v-divider>
        </div>
    </v-card>

    <v-slide-y-transition>
      <v-card class="mt-2" v-if="showAdd">
        <placeholder-form :slug="$route.params.slug" @success="showAdd = false; refresh()"></placeholder-form>
      </v-card>
    </v-slide-y-transition>

    <v-card class="mt-2">
      <v-toolbar v-if="isAdmin" dark flat dense color="primary">
        <v-spacer></v-spacer>
        <v-btn v-if="!showAdd" color="accent" @click="showAdd = true" dark>dodaj</v-btn>
        <v-btn v-if="showAdd" flat small @click="showAdd = false">ukryj</v-btn>
      </v-toolbar>
    </v-card>
</div>
</template>

<script>
import {fetchPage, deletePlaceholder} from './api'
import iziToast from 'izitoast'
import { mapGetters } from 'vuex'
import _ from 'lodash'

import PlaceholderItem from './PlaceholderItem'
const PlaceholderForm = () => import(
  /* webpackChunkName: "placeholder-form" */ './PlaceholderForm.vue'
)

export default {
  name: 'packages',
  components: {PlaceholderForm, PlaceholderItem},
  data () {
    return {
      title: '',
      showAdd: false,
      placeholdersList: []
    }
  },
  computed: {
    ...mapGetters(['isAdmin'])
  },
  created () {
    this.fetchPage()
  },
  watch: {
    '$route': 'fetchPage'
  },
  methods: {
    refresh: _.debounce(function () {
      this.fetchPage()
    }, 400),
    fetchPage () {
      let promise = fetchPage(this.$route.params.slug)

      return promise.then((data) => {
        this.title = data.title
        this.placeholdersList = data.placeholders
      })
    },
    changePlaceholder (item) {
      this.$set(item, 'edit', true)
    },
    removePlaceholder (item) {
      this.$root.$confirm('Usuń element', 'Czy na pewno usunąć ten element?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (willDelete) {
          let promise = deletePlaceholder(this.$route.params.slug, item)
          return promise.then(() => {
            this.refresh()
            iziToast.show({
              message: 'Element został usunięty',
              color: 'green'
            })
          }).catch(() => {
            iziToast.show({
              message: 'Nie udało się usunąć elementu.',
              color: 'red'
            })
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Page.vue